import { executePageLoad, setPageState } from 'actions/page.actions';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectPageState } from 'selectors/page.selector';

export const usePageLoadingAction = c => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(executePageLoad(c));
    //eslint-disable-next-line
  }, []);

  return true;
};

export const usePageState = _ => {
  const pageState = useSelector(selectPageState);
  const setState = usePageStateSetter();
  return [pageState, setState];
};

export const usePageStateSetter = c => {
  const { pageNameType } = c ?? {};
  const dispatch = useDispatch();
  const setState = newStateKeys => {
    dispatch(setPageState(newStateKeys, pageNameType));
  };

  return setState;
};
